
import { Link } from "wouter";

export default function FooterAr() {
  return (
    <footer className="section-dark border-t border-musicGrey/20 pt-16 pb-8 section-transition" dir="rtl">
      <div className="editorial-container">
        {/* ── MAIN CONTENT ───────────────────────────────── */}
        <div className="flex flex-col md:flex-row justify-between gap-12">
          {/* LEFT  ─ logo + tagline */}
          <div className="max-w-sm">
            <Link to="/ar" className="inline-block mb-6">
              <img 
                src="/lovable-uploads/794bcc8e-4338-4129-9bd7-38e76b939a38.png" 
                alt="شعار أمة الموسيقى" 
                className="h-16 w-auto"
              />
            </Link>
            <p className="text-musicGrey font-sans max-w-xs">
              مرخصة رسمياً من وزارة الاقتصاد الإماراتية لإدارة حقوق الموسيقى، لخدمة المبدعين والشركات.
            </p>
          </div>
        </div>
        
        {/* ── BOTTOM BAR ─────────────────────────────────────── */}
        <div className="mt-16 pt-8 border-t border-musicGrey/20 flex flex-col md:flex-row justify-between items-center">
          <div className="text-musicGrey text-sm mb-4 md:mb-0 font-sans">
            © 2025 أمة الموسيقى الإمارات. جميع الحقوق محفوظة.
          </div>
          <div className="flex space-x-6 space-x-reverse">
            <Link to="#" className="text-musicGrey hover:text-musicRed transition-colors font-sans">سياسة الخصوصية</Link>
            <span className="text-musicGrey">·</span>
            <Link to="#" className="text-musicGrey hover:text-musicRed transition-colors font-sans">شروط الخدمة</Link>
            <span className="text-musicGrey">·</span>
            <Link to="/ar/contact" className="text-musicGrey hover:text-musicRed transition-colors font-sans">اتصل بنا</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
